<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/coach' }">
        <app-i18n code="entities.coach.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.coach.edit.title" v-if="isEditing"></app-i18n>
        <app-i18n code="entities.coach.new.title" v-if="!isEditing"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <app-back-button
      route-name="iam"
      :route-params="{ tabName: 'coaches' }"
      i18nCode="entities.coach.label" 
    />

    <h1 class="app-content-title app-content-title--hidden">
      <app-i18n code="entities.coach.edit.title" v-if="isEditing" />
      <app-i18n code="entities.coach.new.title" v-if="!isEditing" />
    </h1>

    <div class="app-content-page">
      <div class="app-page-spinner" v-if="findLoading" v-loading="findLoading"></div>

      <el-form
        v-loading="saveLoading"
        v-if="model"
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        :model="model"
        :rules="rules"
        @submit.native.prevent="doSubmit"
        class="form"
        ref="form"
      >

        <h2 class="app-content-subtitle">
          <app-i18n code="entities.coach.form.subtitle.information" />
        </h2>

      <el-row :gutter="10">
        <el-col :lg="12" :md="12" :sm="24">
          <el-form-item
            :label="fields.type.label"
            :prop="fields.type.name"
            :required="fields.type.required"
          >
              <el-select
                :placeholder="i18n(`entities.coach.placeholders.type`)"
                v-model="model[fields.type.name]"
              >
                <i slot="prefix" class="icon-filters" />
                <el-option :value="undefined">--</el-option>
                <el-option
                  :key="option.id"
                  :label="option.label"
                  :value="option.id"
                  v-for="option in fields.type.options"
                ></el-option>
              </el-select>
          </el-form-item>
          <!-- <el-form-item :label="fields.id.label" :prop="fields.id.name" v-if="isEditing">
            <el-input :disabled="true" v-model="model[fields.id.name]"/>
          </el-form-item> -->
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :lg="12" :md="12" :sm="24">
          <el-form-item
            :label="fields.firstName.label"
            :prop="fields.firstName.name"
            :required="fields.firstName.required"
          >
          
            <el-input
              prefix-icon="icon-player"
              :placeholder="i18n(`entities.coach.placeholders.firstName`)"
              v-model="model[fields.firstName.name]"
            />
          </el-form-item>
        </el-col>
        <el-col :lg="12" :md="12" :sm="24">
          <el-form-item
            :label="fields.lastName.label"
            :prop="fields.lastName.name"
            :required="fields.lastName.required"
          >
            <el-input
              prefix-icon="icon-player"
              :placeholder="i18n(`entities.coach.placeholders.lastName`)"
              v-model="model[fields.lastName.name]"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :lg="12" :md="12" :sm="24">
          <el-form-item
            :label="fields.phoneNumber.label"
            :prop="fields.phoneNumber.name"
            :required="fields.phoneNumber.required"
          >
            <phone-input v-model="model[fields.phoneNumber.name]" />
          </el-form-item>
        </el-col>
        <el-col :lg="12" :md="12" :sm="24">
          <el-form-item
            :label="fields.birthdate.label"
            :prop="fields.birthdate.name"
            :required="fields.birthdate.required"
          >
            <el-date-picker
              type="date"
              :placeholder="i18n('common.date.formatInput')"
              :format="i18n('common.date.formatInput')"
              v-model="model[fields.birthdate.name]">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :lg="12" :md="12" :sm="24">
          <el-form-item
            :label="fields.gender.label"
            :prop="fields.gender.name"
            :required="fields.gender.required"
          >
            <el-select
              :placeholder="i18n(`entities.coach.placeholders.gender`)"
              v-model="model[fields.gender.name]"
            >
              <i slot="prefix" class="icon-family" />
              <el-option :value="undefined">--</el-option>
              <el-option
                :key="option.id"
                :label="option.label"
                :value="option.id"
                v-for="option in fields.gender.options"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :md="12" :sm="24">
          <el-form-item
            :label="fields.country.label"
            :prop="fields.country.name"
            :required="fields.country.required"
          >
            <el-select
              :placeholder="i18n(`entities.coach.placeholders.country`)"
              filterable
              v-model="model[fields.country.name]"
            >
              <i slot="prefix" class="icon-location" />
              <el-option :value="undefined">--</el-option>
              <el-option
                :key="option.id"
                :label="option.label"
                :value="option.id"
                v-for="option in fields.country.options"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :lg="12" :md="24" :sm="24">
          <el-form-item
            :label="fields.email.label"
            :prop="fields.email.name"
            :required="fields.email.required"
          > 
            <!-- Email disabled -->
            <el-tooltip 
              v-if="record && record.lastLogin"
              class="item"  
              effect="dark" 
              :content="i18n('entities.coach.form.tooltip.emailDisabled')" 
              placement="bottom-start"
            >
            <el-input
              disabled
              prefix-icon="icon-mail"
              :placeholder="i18n(`entities.coach.placeholders.email`)"
              v-model="model[fields.email.name]"
            />
            </el-tooltip>
            <!-- Email enabled -->
            <el-input
              v-else
              prefix-icon="icon-mail"
              :placeholder="i18n(`entities.coach.placeholders.email`)"
              v-model="model[fields.email.name]"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <div class="app-content-separator" />

      <h2 class="app-content-subtitle">
        <app-i18n code="entities.coach.form.subtitle.teams" />
      </h2>

      <el-row :gutter="10">
        <el-col :lg="12" :md="12" :sm="24">
          <el-form-item
            :label="fields.teams.label"
            :prop="fields.teams.name"
            :required="fields.teams.required"
          >
              <app-autocomplete-many-input
                prefix-icon="icon-plus"
                :placeholder="i18n(`entities.coach.placeholders.teams`)"
                :disabled="manageInput.program.disabled"
                :fetchFn="fields.teams.fetchFn"
                :key="manageInput.program.key"
                :manage="manageInput.program.values"
                v-model="model[fields.teams.name]"
              ></app-autocomplete-many-input>
          </el-form-item>
        </el-col>
      </el-row>

        <el-form-item>
          <div class="form-buttons">
            <el-button
              :disabled="saveLoading"
              @click="doSubmit"
              icon="el-icon-fa-floppy-o"
              type="primary"
            >
              <app-i18n code="common.save"></app-i18n>
            </el-button>

            <!-- <el-button :disabled="saveLoading" @click="doReset" icon="el-icon-fa-undo">
              <app-i18n code="common.reset"></app-i18n>
            </el-button> -->
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FormSchema } from '@shared/form/form-schema';
import { CoachModel } from '@modules/coach/coach-model';
import { i18n } from '@shared/i18n';
import objectPath from 'object-path';
import Manage from '@shared/manage/manage-model';
import 'fix-date';

export default {
  name: 'app-coach-form-page',

  props: ['id', 'email'],

  data() {
    return {
      model: null,
      manageInput: {
        program: {
          key: 0,
          required: true,
          values: { type: 'program' },
        },
        subprogram: {
          key: 0,
          required: true,
          values: { type: 'subprogram' },
        },
      },
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'coach/form/record',
      findLoading: 'coach/form/findLoading',
      saveLoading: 'coach/form/saveLoading',
      currentManage: 'auth/manage/currentManage',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),

    isEditing() {
      return !!this.id;
    },

    rules() {
      const { formSchema } = this;
      return formSchema.rules();
    },
    
    formSchema() {
      const { fields } = this;
      return new FormSchema([
        fields.id,
        fields.teams,
        fields.firstName,
        fields.lastName,
        fields.birthdate,
        fields.email,
        fields.phoneNumber,
        fields.gender,
        fields.country,
        fields.type,
      ]);
    },

    fields() {
      const { dateFormat, timeFormat} = this;
      return new CoachModel({ dateFormat, timeFormat }).fields();
    },

    teamPrograms() {
      return (programsObject) => {
        if (!programsObject) return [];
        return Object.keys(programsObject).map((id) => ({
          id,
        }));
      };
    },

    teamSubprograms() {
      return (programsObject) => {
        const subprograms = [];

        if (programsObject) {
          Object.values(programsObject).forEach(
            (programObject) => {
              if (!('subprograms' in programObject)) return;
              if (!programObject.subprograms) return;
              subprograms.push(
                ...Object.keys(programObject.subprograms),
              );
            },
          );
        }

        return subprograms.map((id) => ({ id }));
      };
    },

  },

  async created() {
    const { formSchema } = this;
    this.manageInput.program.values = new Manage(
      this.currentManage,
    ).getManageModel();
    this.manageInput.program.key++;

    if (this.isEditing) {
      await this.doFind(this.id);
      this.model = formSchema.initialValues(this.record);
      this._loadModelPerManage(this.record);
    } else {
      await this.doNew(this.currentManage);
      this.model = formSchema.initialValues(this.record);
    }
  },

  methods: {
    ...mapActions({
      doFind: 'coach/form/doFind',
      doNew: 'coach/form/doNew',
      doUpdate: 'coach/form/doUpdate',
      doCreate: 'coach/form/doCreate',
    }),

    _loadModelPerManage({ programs }) {
      if (!programs) return;

      if (this.teamPrograms(programs).length === 1) {
        objectPath.set(
          this.manageInput,
          'program.disabled',
          true,
        );
        objectPath.set(
          this.manageInput,
          'subprogram.disabled',
          true,
        );
        objectPath.set(this.model, 'program', {
          id: this.teamPrograms(programs)[0].id,
        });

        if (this.teamSubprograms(programs).length === 1) {
          objectPath.set(
            this.manageInput,
            'subprogram.disabled',
            true,
          );
          objectPath.set(this.model, 'subprogram', {
            id: this.teamSubprograms(programs)[0].id,
          });
        }
      }
    },

    doReset() {
      const { formSchema } = this;
      this.model = formSchema.initialValues(this.record);
    },

    async doSubmit() {
      const { formSchema } = this;
      try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }

      const { id, ...values } = formSchema.cast(this.model);

      if (this.isEditing) {
        return this.doUpdate({
          id,
          values,
          manage: this.currentManage,
        });
      } else {
        return this.doCreate({
          values,
          manage: this.currentManage,
        });
      }
    },
    i18n(code) {
      return i18n(code);
    },
  },
  watch: {
    'model.program.id'(newId) {
      objectPath.set(
        this.manageInput,
        'program.values.programId',
        newId,
      );
      this.manageInput.subprogram.values = this.manageInput.program.values;
      this.manageInput.subprogram.key += 1;
    },
    'model.subprogram.id'(newId) {
      this.manageInput.subprogram.values.subprogramId = newId;
    },
  },
};
</script>

<style>
</style>
